import type { CSSProperties } from "react"
import type { UVInsertFaceElementType } from "@shared/models/uv-inserts"
import styles from "./visualiser.module.css"

function cssUrlValue(url: string): string {
  return url.replace(/\\/g, "\\\\").replace(/"/g, '\\"')
}

/**
 * Presentation state for the outer Visualiser frame (layout, CSS variables, subtitle wrapper).
 */
export function getVisualiserViewModel(options: {
  type: UVInsertFaceElementType
  isGrouped?: boolean
  background?: string
  /** When set, drawn as cover over solid `background` (e.g. selected theme variant image on front). */
  backgroundImageUrl?: string | null
  gap?: string
  subtitle?: string
}) {
  const { type, isGrouped, background, backgroundImageUrl, gap, subtitle } = options
  const typeStyle =
    type === "INSERT"
      ? styles["visualiser--insert"]
      : type === "GREETINGS_CARD"
        ? styles["visualiser--greetingsCard"]
        : ""
  const groupedStyle = isGrouped ? styles["visualiser--grouped"] : ""
  const visualiserClassName = [styles["visualiser"], typeStyle, groupedStyle].filter(Boolean).join(" ")
  const solid = background || "var(--color-white)"
  const visualiserStyle = {
    "--vis-gap": gap,
    ...(backgroundImageUrl
      ? ({
          backgroundColor: solid,
          backgroundImage: `url("${cssUrlValue(backgroundImageUrl)}")`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        } as CSSProperties)
      : ({ background: solid } as CSSProperties)),
  } as CSSProperties
  return {
    visualiserClassName,
    visualiserStyle,
    subtitleContainerClassName: styles["visualiser-subtitle-container"],
    hasSubtitle: Boolean(subtitle),
  }
}
